export default {"src":"https://fishbrain.com/_next/static/media/full_moon.b5c9699c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};